import { useId } from 'react';
import { useTheme, type ThemeChoice } from '../lib/theme';
import { Icon, type IconName } from './Icon';

const OPTIONS: { value: ThemeChoice; label: string; icon: IconName }[] = [
  { value: 'light', label: 'Light', icon: 'sun' },
  { value: 'dark', label: 'Dark', icon: 'moon' },
  { value: 'system', label: 'System', icon: 'monitor' },
];

/** Segmented radio group — three states, so not a toggle button. */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { choice, setTheme } = useTheme();
  const name = useId();
  return (
    <fieldset className="fl-segmented m-0 border-0">
      <legend className="sr-only">Theme</legend>
      {OPTIONS.map((o) => (
        <label
          key={o.value}
          className="relative justify-center has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-ink"
        >
          <input
            type="radio"
            name={name}
            value={o.value}
            checked={choice === o.value}
            onChange={() => setTheme(o.value)}
            className="sr-only"
          />
          <Icon name={o.icon} size={16} />
          <span className={compact ? 'sr-only' : ''}>{o.label}</span>
        </label>
      ))}
    </fieldset>
  );
}
